<template>
  <!--  IMPORTANT: don't forget change content on both versions (desktop & mobile)-->
  <div v-if="UserAgent.window.width > mobileResolution" class="table screen_table--4" :class="{ 'table--red': activeTab === 2 }">
    <div class="table__top">
      <img class="table__top_img" src="@/assets/table-img.gif" alt="table-img">
    </div>
    <table class="table__wrapper" ref="table">
      <thead class="table__thead">
        <tr class="table__tr">
          <th class="table__th table__th--first" rowspan="5" v-html="tableMainCell"></th>
          <th class="table__th table__th--second" colspan="4">
            <div class="table__colon_bg" :style="{'height': height + 'px'}"></div>
            <div class="table__th_buttons">
              <div v-html="tableButtons[0]" class="table__th_buttons_item screen__table_btn--1" @click="activeTab = 0; DLPButtonClick(tableButtons[0]);" :class="{'table__th_buttons_item--active': activeTab === 0}"></div>
              <div v-html="tableButtons[1]" class="table__th_buttons_item screen__table_btn--2" @click="activeTab = 1; DLPButtonClick(tableButtons[1]);" :class="{'table__th_buttons_item--active': activeTab === 1}"></div>
              <div v-html="tableButtons[2]" @click="activeTab = 2; DLPButtonClick(tableButtons[2]);" class="table__th_buttons_item table__th_buttons_item--last screen__table_btn--3" :class="{'table__th_buttons_item--active': activeTab === 2}"></div>
            </div>
          </th>
        </tr>
        <tr class="table__tr">
          <th class="table__th table__th--second" colspan="4">
            <div class="table__th_decor"></div>
          </th>
        </tr>
        <tr class="table__tr">
          <th class="table__th table__th--second" :colspan="activeTab === 2 ? 4 : 2">
            <div v-if="activeTab === 0" class="table__th_content" v-html="tableLLN[0]"></div>
            <div v-if="activeTab === 1" class="table__th_content" v-html="tableLLN[2]"></div>
            <div v-if="activeTab === 2" class="table__th_content" v-html="tableLLN[4]"></div>
          </th>
          <th v-if="activeTab !== 2" class="table__th table__th--second" colspan="2">
            <div v-if="activeTab === 0" class="table__th_content" v-html="tableLLN[1]"></div>
            <div v-if="activeTab === 1" class="table__th_content" v-html="tableLLN[3]"></div>
          </th>
        </tr>
        <tr class="table__tr">
          <th class="table__th table__th--second" :colspan="activeTab === 2 ? 2 : 1">
            <div class="table__th_content" v-html="tableMeasurementUnits[0]"></div>
          </th>
          <th class="table__th table__th--second" :colspan="activeTab === 2 ? 2 : 1">
            <div class="table__th_content" v-html="tableMeasurementUnits[1]"></div>
          </th>
          <th v-if="activeTab !== 2" class="table__th table__th--second">
            <div class="table__th_content" v-html="tableMeasurementUnits[0]"></div>
          </th>
          <th v-if="activeTab !== 2" class="table__th table__th--second">
            <div class="table__th_content" v-html="tableMeasurementUnits[1]"></div>
          </th>
        </tr>
        <tr class="table__tr">
          <th class="table__th" colspan="2">
            <div class="table__th_decor"></div>
          </th>
          <th class="table__th" colspan="2">
            <div class="table__th_decor"></div>
          </th>
        </tr>
      </thead>
      <tbody class="table__tbody">
        <tr class="table__tr" v-for="(item, index) of tableBodyContent">
          <td class="table__td table__td--first" v-html="item[0]" :class="{'table__td--fixed table__td--padding': index !== 0}"></td>
          <td class="table__td" :colspan="activeTab === 2 ? 2 : 1">
            <span v-if="activeTab === 0" v-html="item[1]"></span>
            <span v-if="activeTab === 1" v-html="item[5]"></span>
            <span v-if="activeTab === 2" v-html="item[9]"></span>
          </td>
          <td class="table__td" :colspan="activeTab === 2 ? 2 : 1">
            <span v-if="activeTab === 0" v-html="item[2]"></span>
            <span v-if="activeTab === 1" v-html="item[6]"></span>
            <span v-if="activeTab === 2" v-html="item[10]"></span>
          </td>
          <td class="table__td" v-if="activeTab !== 2">
            <span v-if="activeTab === 0" v-html="item[3]"></span>
            <span v-if="activeTab === 1" v-html="item[7]"></span>
          </td>
          <td class="table__td" v-if="activeTab !== 2">
            <span v-if="activeTab === 0" v-html="item[4]"></span>
            <span v-if="activeTab === 1" v-html="item[8]"></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div v-else class="table table--mobile screen_table--4" :class="{ 'table--red': activeTab === 2 }">
    <ScrollTable
        :swipe-icon="true"
        class=""
        :delay-before-init="0"
        :fixed-side-class="'table__td--fixed'"
        :resolution="mobileResolution"
        :table-min-width="'950px'"
    >
      <table class="table__wrapper" ref="table">
        <thead class="table__thead">
        <tr class="table__tr">
          <th class="table__th table__th--first table__td--fixed" rowspan="4">
            <div class="table__colon_bg" :style="{'height': height + 'px'}"></div>
            <div class="table__th_content" v-html="tableMainCell"></div>
          </th>
          <th class="table__th table__th--second" colspan="4">
            <div class="table__colon_bg" :style="{'height': height + 'px'}"></div>
            <div class="table__th_decor"></div>
            <div class="table__th_content table__th_content--top">
              <b v-html="tableButtons[0]"></b>
            </div>
          </th>
          <th class="table__th table__th--second" colspan="4">
            <div class="table__colon_bg" :style="{'height': height + 'px'}"></div>
            <div class="table__th_decor"></div>
            <div class="table__th_content table__th_content--top">
              <b v-html="tableButtons[1]"></b>
            </div>
          </th>
          <th class="table__th table__th--second" colspan="2">
            <div class="table__colon_bg table__colon_bg--red" :style="{'height': height + 'px'}"></div>
            <div class="table__th_decor table__th_decor--white"></div>
            <div class="table__th_content table__th_content--white">
              <b v-html="tableButtons[2]"></b>
            </div>
          </th>
        </tr>
        <tr class="table__tr">
          <th class="table__th table__th--second" colspan="2" v-html="tableLLN[0]"></th>
          <th class="table__th table__th--second" colspan="2" v-html="tableLLN[1]"></th>
          <th class="table__th table__th--second" colspan="2" v-html="tableLLN[2]"></th>
          <th class="table__th table__th--second" colspan="2" v-html="tableLLN[3]"></th>
          <th class="table__th table__th--second table__th--white" colspan="2" v-html="tableLLN[4]"></th>
        </tr>
        <tr class="table__tr">
          <th class="table__th table__th--second">
            <div class="table__th_content" v-html="tableMeasurementUnits[0]"></div>
          </th>
          <th class="table__th table__th--second">
            <div class="table__th_content" v-html="tableMeasurementUnits[1]"></div>
          </th>
          <th class="table__th table__th--second">
            <div class="table__th_content" v-html="tableMeasurementUnits[0]"></div>
          </th>
          <th class="table__th table__th--second">
            <div class="table__th_content" v-html="tableMeasurementUnits[1]"></div>
          </th>
          <th class="table__th table__th--second">
            <div class="table__th_content" v-html="tableMeasurementUnits[0]"></div>
          </th>
          <th class="table__th table__th--second">
            <div class="table__th_content" v-html="tableMeasurementUnits[1]"></div>
          </th>
          <th class="table__th table__th--second">
            <div class="table__th_content" v-html="tableMeasurementUnits[0]"></div>
          </th>
          <th class="table__th table__th--second">
            <div class="table__th_content" v-html="tableMeasurementUnits[1]"></div>
          </th>
          <th class="table__th table__th--second table__th--white">
            <div class="table__th_content" v-html="tableMeasurementUnits[0]"></div>
          </th>
          <th class="table__th table__th--second table__th--white">
            <div class="table__th_content" v-html="tableMeasurementUnits[1]"></div>
          </th>
        </tr>
        <tr class="table__tr">
          <th class="table__th" colspan="2">
            <div class="table__th_decor"></div>
          </th>
          <th class="table__th" colspan="2">
            <div class="table__th_decor"></div>
          </th>
          <th class="table__th" colspan="2">
            <div class="table__th_decor"></div>
          </th>
          <th class="table__th" colspan="2">
            <div class="table__th_decor"></div>
          </th>
          <th class="table__th" colspan="2">
            <div class="table__th_decor table__th_decor--white"></div>
          </th>
        </tr>
        </thead>
        <tbody class="table__tbody">
          <tr class="table__tr" v-for="(item, index) of tableBodyContent">
            <td class="table__td table__td--first table__td--fixed" :class="{'table__td--fixed table__td--padding': index !== 0}">
              <span v-html="item[0]"></span>
            </td>
            <td class="table__td">
              <span v-html="item[1]"></span>
            </td>
            <td class="table__td">
              <span v-html="item[2]"></span>
            </td>
            <td class="table__td">
              <span v-html="item[3]"></span>
            </td>
            <td class="table__td">
              <span v-html="item[4]"></span>
            </td>
            <td class="table__td">
              <span v-html="item[5]"></span>
            </td>
            <td class="table__td">
              <span v-html="item[6]"></span>
            </td>
            <td class="table__td">
              <span v-html="item[7]"></span>
            </td>
            <td class="table__td">
              <span v-html="item[8]"></span>
            </td>
            <td class="table__td table__td--white">
              <span v-html="item[9]"></span>
            </td>
            <td class="table__td table__td--white">
              <span v-html="item[10]"></span>
            </td>
          </tr>
        </tbody>
      </table>
    </ScrollTable>
  </div>
</template>

<script>
// vuex
import { mapState } from 'vuex';

// components
import ScrollTable from '../ScrollTable/ScrollTable';
import Analytics from '../../mixins/Analytics';

export default {
  name: "Table4",
  data() {
    return {
      height: 0,
      activeTab: 0,
      borderSpace: 8,
      tableMainCell: 'Patients with ≥1 serious infection within <nobr>1 month</nobr> prior and until <nobr>1 month</nobr> after any series of drop in IgM/IgG levels &lt;LLN',
      tableButtons: [ // can be only 3 items
          'IgM',
          'IgG',
          'Overall',
      ],
      tableLLN: [ // can be only 5 items
          '&lt;LLN <br> (N=454<sup>†</sup>)',
          '≥LLN <br> (N=1512<sup>‡</sup>)',
          '&lt;LLN\ <br> (N=30<sup>†</sup>)',
          '≥LLN <br> (N=1936<sup>‡</sup>)',
          '<br> <br> (N=1969)',
      ],
      tableMeasurementUnits: [ // can be only 2 items
          'n (%)',
          'IR<sup>§</sup>'
      ],
      tableBodyContent: [ // unlimited - on new item, will created new tr
          ['Patients with ≥1 serious infection', '3 (0.7) 111', '0.80', '44 (2.9)', '1.38', '1 (3.3)', '7.02', '55 (2.8)', '1.34', '58 (2.9)', '1.39'], // can be only 11 items
          ['Herpes zoster (PT)', '1 (0.2)', '0.27', '0', '0', '0', '0.27', '1 (0.1)', '0.02', '1 (0.1)', '0.02'],
          ['URTI (PT)', '1 (0.2)', '0.27', '0', '1 (0.1)', '0', '0.27', '1 (0.1)', '0.02', '1 (0.1)', '0.02'],
          ['UTI (PT)', '1 (0.2)', '0.27', '3 (0.2)', '0.09', '0', '0.27', '6 (0.3)', '0.14', '6 (0.3)', '0.14'],
          ['Escherichia UTI (PT)', '0', '0', '1 (0.1)', '0.03', 'NA', 'NA', 'NA', 'NA', '1 (0.1)', '0.02'],
          ['Kidney infection (PT)', '0', '0', '1 (0.1)', '0.03', 'NA', 'NA', 'NA', 'NA', '1 (0.1)', '0.02'],
          ['Pneumonia (PT)', '0', '0', '8 (0.5)', '0.25', '1 (3.3)', '7.02', '8 (0.4)', '0.19', '9 (0.5)', '0.21'],
      ]
    }
  },
  components: {
    ScrollTable
  },
  computed: {
    ...mapState(['UserAgent']),
    mobileResolution() {
      return (
          this.$route.query.screentest_graphs ? Infinity :
          this.UserAgent.window.width >= 1024 ? 1250 : 600
      )
    }
  },
  mounted() {
    this.height = this.$refs.table.offsetHeight - this.borderSpace;
  },
  updated() {
    this.height = this.$refs.table.offsetHeight - this.borderSpace;
  },
  mixins: [Analytics]
}
</script>

<style scoped lang="scss">
$border-space: 8px;

.table {
  line-height: normal;
  position: relative;
  width: 100%;
  &__top {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
  &__top_img {
    width: 50px;
    height: 100%;
  }
  &__wrapper {
    border-collapse: separate;
    border-spacing: $border-space;
    width: 100%;
    margin: -$border-space;
    padding-bottom: $border-space;
  }
  &__th {
    font-size: 18px;
    color: $table-color-1;
    position: relative;
    font-weight: 400;
    margin-bottom: 25px;
    @media (max-width: $mobile) {
      font-size: 16px;
    }
    &--first {
      color: $table-bg-3;
      text-align: left;
      font-weight: 700;
      max-width: 200px;
      vertical-align: top;
      .table--mobile & {
        width: 175px;
      }
    }
    &--second,
    &--third {
      text-align: center;
    }
    &--third {
      color: white;
    }
    .table--red & {
      &:not(.table__th--first) {
        color: white;
      }
    }
    &--white {
      color: white;
    }
  }
  &__th_content {
    position: relative;
    &--top {
      font-size: 20px;
      line-height: 1.1;
    }
    &--white {
      color: white;
    }
  }
  &__th_decor {
    position: absolute;
    top: auto;
    bottom: -$border-space/2;
    background-color: $table-color-1;
    height: 2px;
    width: calc(100% - #{$border-space * 2});
    left: $border-space;
    .table__th--third & {
      background-color: white;
    }
    .table--red & {
      background-color: white;
    }
    &--white {
      background-color: white;
    }
  }
  &__colon_bg {
    position: absolute;
    width: 100%;
    background-color: $table-bg-1;
    border-radius: 8px;
    top: -$border-space;
    .table__th--first & {
      background-color: white;
      border-radius: 0;
      .scroll_table--cloned & {
        min-height: 1000vh;
        left: -$border-space;
        right: -$border-space/2;
        width: auto;
      }
    }
    .table__th--third & {
      background-image: linear-gradient(148deg, $table-bg-2 10%, $table-bg-3 89%);
    }
    &--red,
    .table--red & {
      background-color: $table-bg-4;
    }
  }
  &__th_buttons {
    position: relative;
    min-width: 354px;
    display: flex;
    justify-content: space-between;
    margin: 0 $border-space;
  }
  &__th_buttons_item {
    font-size: 24px;
    font-weight: 700;
    line-height: 0.92;
    border: 1px solid transparent;
    width: 32%;
    text-align: center;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    background-color: white;

    &:not(.table__th_buttons_item--active) {
      box-shadow: 0px 3px 10px -5px black;
    }

    .table--red & {
      border-color: white;
      background-color: transparent;
    }

    &:hover,
    &--active {
      color: white;
      background-color: $table-color-1;
      transition: .5s;
      .screentest & {
        transition: 0s;
      }
      .table--red & {
        background-color: white;
        color: $table-bg-4;
      }
    }

    &--last {
      &:hover {
        background-color: $table-bg-4;
        color: white;
      }
    }

  }
  &__td {
    color: $table-color-1;
    font-size: 18px;
    position: relative;
    @media (max-width: $mobile) {
      font-size: 16px;
    }
    &:not(&--first) {
      text-align: center;
    }
    &--subtitle {
      font-size: 12px;
      font-weight: 700;
    }
    &--first {
      overflow: hidden;
      &:after {
        content: "........................................................................................................................................................................................................................................................................................................................................";
        width: 1px;
        display: inline-block;
        font-size: 50%;
      }
    }
    &--second,
    &--third {
      text-align: center;
    }
    &--third {
      color: white;
    }
    &--padding {
      padding-left: 10px;
    }
    .table--red & {
      &:not(.table__td--first) {
        color: white;
      }
    }
    &--white {
      color: white;
    }
  }
}
</style>
